import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { CurrencyType } from '../../../../constants/currencies';
import { SVGIconType } from '../../../../constants/svgIcon';
import {
  GeneralModal,
  GeneralModalNoButtonVariant,
  GeneralModalYesButtonVariant,
  SvgIcon,
  TextInput,
} from '../../../Molecules';

import styles from './CreateJourneyModal.module.css';

type TextInputProps = {
  value: string;
  errorMessage?: string;
  maxLength: number;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

type CreateJourneyModalProps = {
  memoryBoostDays: number;
  title: TextInputProps;
  currencyType: CurrencyType;
  fee: number;
  onPrimary: () => void;
  onPressCancel: () => void;
  onPressMemoryBoost: () => void;
};

export const CreateJourneyModal = (props: CreateJourneyModalProps) => {
  const {
    memoryBoostDays,
    title,
    currencyType,
    fee,
    onPrimary,
    onPressCancel,
    onPressMemoryBoost,
  } = props;
  const { t } = useTranslation();

  return (
    <GeneralModal
      isYesNo={true}
      onYes={onPrimary}
      onClose={onPressCancel}
      buttonSetting={{
        noText: t('Cancel'),
        noVariant: GeneralModalNoButtonVariant.Gray,
        yesVariant: GeneralModalYesButtonVariant.Cyan,
        yesFee: {
          type: currencyType,
          amount: fee,
        },
      }}
    >
      <div className={styles.journey}>
        <div className={styles.centerContainer}>
          <SvgIcon
            name={SVGIconType.Journey}
            className={styles.titleIcon}
            stroke={'#000000'}
          />
          <p className={styles.titleName}>{t('Journey Name')}</p>
          <TextInput
            value={title.value}
            onChange={title.onChange}
            placeholder={t('Journey Name')}
            style={{
              backgroundColor: '#f1f1f1',
              color: '#000',
            }}
            maxLength={title.maxLength}
            errorMessage={title.errorMessage}
          />
          <p className={styles.textTitle}>{t('JOYAJOY AI Memory Boost')}</p>
          <p className={styles.textMinor}>
            {t('Enhance your memory retention by up to 9 times.')}
          </p>
          <div className={styles.containerGray} onClick={onPressMemoryBoost}>
            <SvgIcon
              name={SVGIconType.Ai}
              className={styles.aiIcon}
              stroke={'#000000'}
              fill={'#000000'}
              color={'#000000'}
            />
            <p className={styles.textNormal}>{t('AI Memory Boost')}</p>
            <div className={styles.containerRight}>
              <p className={styles.textMinor}>
                {memoryBoostDays > 0
                  ? `${memoryBoostDays} ${t(
                      memoryBoostDays === 1 ? 'day' : 'days',
                    )}`
                  : 0}
              </p>
              <SvgIcon
                name={SVGIconType.Arrow}
                className={styles.titleIcon}
                stroke={'#808080'}
              />
            </div>
          </div>
          <p className={styles.textCaption}>
            {t('Create the Journey of AI Games?')}
          </p>
        </div>
      </div>
    </GeneralModal>
  );
};
